<div class="default-workspaces-ch-panels flex-grow">
  <div class="ch-panel">
    <a
      (click)="switchTabs('inviteMessage')"
      [ngClass]="{ active: inviteMessage }"
      >Invite Message</a
    >
    <a (click)="switchTabs('clientTasks')" [ngClass]="{ active: clientTasks }"
      >Client Tasks</a
    >
    <a
      (click)="switchTabs('appsAndResources')"
      [ngClass]="{ active: appsAndResources }"
      >Apps & Resources</a
    >
    <a (click)="switchTabs('folders')" [ngClass]="{ active: folders }"
      >Folders</a
    >
    <a (click)="switchTabs('clientData')" [ngClass]="{ active: clientData }"
      >Client Data</a
    >

    <a (click)="switchTabs('contactData')" [ngClass]="{ active: contactData }"
      >Contact Data</a
    >
  </div>
  <div class="ch-panel-content d-flex flex-column flex-grow">
    <!-- Default invite message component -->
    <app-invite-message *ngIf="inviteMessage" [defaultEmail]="defaultEmail">
    </app-invite-message>

    <!-- Default client tasks component -->
    <app-df-client-tasks
      [user]="user"
      *ngIf="clientTasks"
    ></app-df-client-tasks>
    <!-- Default apps and resources component -->
    <app-apps-and-resources
      *ngIf="appsAndResources"
      [data]="data"
      [company]="company"
    ></app-apps-and-resources>

    <!-- Default folders component -->
    <app-folders
      [data]="data"
      [company]="company"
      [user]="user"
      *ngIf="folders"
    ></app-folders>

    <!-- Client data component -->

    <app-client-data [company]="company" *ngIf="clientData"></app-client-data>

    <!-- Contact data component -->

    <app-contact-data *ngIf="contactData"></app-contact-data>
  </div>
</div>
